import React from "react";

type Props={children:React.ReactNode;resetKey:string;onBack:()=>void};
type State={errorCode:string};

export class MaintenanceEditorBoundary extends React.Component<Props,State>{
  state:State={errorCode:""};
  static getDerivedStateFromError(){return{errorCode:`SGQ-EDITOR-${Date.now().toString(36).toUpperCase()}`}}
  componentDidCatch(error:Error){
    if(import.meta.env.DEV)console.error("maintenance_editor_failed",{name:error.name,message:error.message});
  }
  componentDidUpdate(previous:Props){
    if(previous.resetKey!==this.props.resetKey&&this.state.errorCode)this.setState({errorCode:""});
  }
  render(){
    if(!this.state.errorCode)return this.props.children;
    return <section className="card editor-fallback" role="alert">
      <h2>NÃO FOI POSSÍVEL CARREGAR O EDITOR DE MANUTENÇÃO.</h2>
      <p>Tente novamente. Se o problema continuar, informe o código abaixo ao suporte.</p>
      <code>{this.state.errorCode}</code>
      <div className="actions">
        <button type="button" className="button primary" onClick={()=>this.setState({errorCode:""})}>Tentar novamente</button>
        <button type="button" className="button" onClick={this.props.onBack}>Voltar para manutenções</button>
        <button type="button" className="button" onClick={()=>void navigator.clipboard?.writeText(this.state.errorCode)}>Copiar código do erro</button>
      </div>
    </section>;
  }
}

